import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/rc-rate/es/index.js
// module id = 742
// module chunks = 0